import { Component, HostListener } from '@angular/core';
import { CommonService } from './core/services/common.service';
import { CommonCommunicationService } from './core/services/commonCommunication.service';
// import { SocketService } from './core/services/socket.service';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Btc Admin';
  moduleListData: any = [];
  roleDetails: any = {};
  groupDetails: any = {};
  groupName = '';
  userDetails: any = {};

  constructor(
    private commonService: CommonService,
    private ccs: CommonCommunicationService,
    // private socketService: SocketService,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (!localStorage.getItem('clear')) {
      localStorage.clear();
      localStorage.setItem('clear', 'true');
      location.reload();
    }
    let token: any = JSON.parse(localStorage.getItem('token') || '{}');

    this.ccs.setJwtToken(token);
    this.userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    if (this.userDetails._id) {
      this.ccs.setUserData(this.userDetails);
      this.ccs.setActiveShopId(this.userDetails.shopId[0]);
      this.groupName = this.userDetails.role;
      this.getFeatureList();
    }
  }

  public image1 = '../assets/images/1.png';
  public image2 = '../assets/images/2.png';
  public image3 = '../assets/images/3.png';
  public image4 = '../assets/images/4.png';

  getFeatureList() {
    this.commonService.getAllModule().subscribe((res) => {
      res.data.forEach((element: any) => {
        this.moduleListData[element._id] = element.moduleName;
      });
      this.getRoleList();
    });
  }
  getRoleList() {
    this.userService.getAllRole({}, 1, 100).subscribe((res) => {
      res.data.forEach((element: any) => {
        this.roleDetails[element.name] = element;
      });
      this.getGroupList();
    });
  }
  getGroupList() {
    this.commonService.getAllGroup({}, 1, 100).subscribe((res) => {
      res.data.forEach((element: any) => {
        this.groupDetails[element._id] = element;
      });
      this.getGroupInfo();
    });
  }
  getGroupInfo() {
    let data = this.userDetails;
    let role = this.roleDetails[data.role];

    let moduleData: any = [];

    role.groups.forEach((item: any) => {
      moduleData = [...moduleData, ...this.groupDetails[item].module_list];
    });

    moduleData = moduleData.map((item: any) => ({
      ...item,
      moduleName: this.moduleListData[item.module_id],
    }));

    this.ccs.setModuleList(moduleData);

    this.ccs.setUserData(data);
  }
  // window.addEventListener('wheel', { passive: false })
}
